module.exports = __webpack_public_path__ + "img/unchecked-favor.8d702a43.svg";